// extracted by mini-css-extract-plugin
export default {"table-container":"templates-hotel-budget-module__table-container"};